package com.arenaproplay.admin.ui.components.tabs

import androidx.compose.runtime.*
import com.arenaproplay.admin.ui.theme.AppColors
import com.arenaproplay.admin.ui.utils.Constants
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

data class TabItem(
    val key: String,
    val label: String,
    val content: @Composable () -> Unit
)

@Composable
fun Tabs(
    tabs: List<TabItem>,
    modifier: Modifier = Modifier,
    selectedTabKey: String? = null,
    onTabSelected: ((String) -> Unit)? = null
) {
    var selectedKey by remember { mutableStateOf(selectedTabKey ?: tabs.firstOrNull()?.key ?: "") }
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Column(modifier.fillMaxWidth()) {
        Row(
            Modifier
                .fillMaxWidth()
                .borderBottom(1.px, LineStyle.Solid, colors.border)
        ) {
            tabs.forEach { tab ->
                val isSelected = tab.key == selectedKey

                Box(
                    Modifier
                        .padding(topBottom = 12.px, leftRight = 16.px)
                        .cursor(Cursor.Pointer)
                        .borderBottom(
                            width = 2.px,
                            style = LineStyle.Solid,
                            color = if (isSelected) AppColors.Primary
                            else org.jetbrains.compose.web.css.Color("transparent")
                        )
                        .margin(bottom = (-1).px)
                        .transition(
                            Transition.of("color", Constants.ANIMATION_FAST.ms),
                            Transition.of("border-color", Constants.ANIMATION_FAST.ms)
                        )
                        .onClick {
                            selectedKey = tab.key
                            onTabSelected?.invoke(tab.key)
                        }
                ) {
                    SpanText(
                        tab.label,
                        modifier = Modifier
                            .fontSize(14.px)
                            .fontWeight(if (isSelected) FontWeight.SemiBold else FontWeight.Normal)
                            .color(if (isSelected) colors.textPrimary else colors.textSecondary)
                    )
                }
            }
        }

        Box(Modifier.fillMaxWidth().padding(top = 16.px)) {
            tabs.find { it.key == selectedKey }?.content?.invoke()
        }
    }
}
